import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7ca08ed6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "d-flex flex-column flex-lg-row flex-column-fluid",
  id: "login-container"
}
const _hoisted_2 = {
  class: "d-flex flex-column flex-lg-row-fluid flex-lg-row-auto py-10 w-50-p",
  style: {"background":"#fff"}
}
const _hoisted_3 = { class: "d-flex flex-center flex-column flex-column-fluid" }
const _hoisted_4 = { class: "w-lg-500px p-10 p-lg-15 mx-auto login-form-container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-10" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-dark mb-3 text-sign-in" }, "Forgot Password"),
  /*#__PURE__*/_createElementVNode("div", { class: "fs-4 subtext-sign-in" }, " Enter your email to reset your password ")
], -1))
const _hoisted_6 = { class: "login-links" }
const _hoisted_7 = {
  class: "d-flex w-50-p aside justify-content-center align-items-center",
  style: {"background-color":"#1a4db4"}
}
const _hoisted_8 = { class: "d-flex flex-column justify-content-center align-items-center pt-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainLogo = _resolveComponent("MainLogo")!
  const _component_ForgotPasswordForm = _resolveComponent("ForgotPasswordForm")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_MainLogo, { class: "logo-app-mobile m-auto" }),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_ForgotPasswordForm),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_router_link, {
              to: "/sign-up",
              class: "link",
              style: {"margin-right":"40px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode("About")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/sign-up",
              class: "link"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Support")
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_MainLogo, { class: "logo" })
      ])
    ])
  ]))
}